import { z } from 'zod';

/**
 * Wire schemas for review API responses
 * These match the backend response format (snake_case)
 */

/**
 * Review status enum
 */
export const reviewStatusSchema = z.enum(['draft', 'pending', 'active', 'archived']);
export type ReviewStatus = z.infer<typeof reviewStatusSchema>;

/**
 * Review wire schema (matches backend response format)
 * Based on ReviewReadSchema from Gateway
 */
export const reviewWireSchema = z.object({
  id: z.string(),
  check_in_id: z.string(),
  user_id: z.string(),
  content: z.string(),
  status: reviewStatusSchema,
  created_at: z.string(), // D1 DATETIME (ISO format)
  updated_at: z.string(), // D1 DATETIME (ISO format)
});

export type ReviewWire = z.infer<typeof reviewWireSchema>;

/**
 * Review creation data
 */
export const reviewCreateSchema = z.object({
  content: z.string().min(1, 'Review content must not be empty').max(500),
});

export type ReviewCreate = z.infer<typeof reviewCreateSchema>;
